// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.profile-basic-information-modal__content {
    margin: 0 85px;
}


.profile-basic-information-modal__weight-height {
    display: flex;
    align-items: center;
    gap: 16px;
}

.profile-basic-information-modal .modal2__container {
    width: 30%;
}

.input-field.profile-basic-information-modal__birthday {
    margin: 54px 0 0 0;

}

.profile-basic-information-modal__title.baloa-table-column {
    color: var(--primary-very-dark-color);
    margin-top: 18px;
}

.profile-basic-information-modal__birthday .input-field-input {
    width: 50%;
    background-color: var(--white-color);
    border: 1px solid var(--new-input-background-color);
}

.profile-basic-information-modal__weight.input-field,
.profile-basic-information-modal__height.input-field {
    width: 45%;
    margin: 45px 0 0 0;
}

.profile-basic-information-modal__unit-type.select-field {
    margin: 45px 0 0 0;
    width: 25%;
}

.profile-basic-information-modal__actions {
    display: flex;
    justify-content: flex-end;
    border-top: 1px solid var(--new-input-background-color);
}

.profile-basic-information-modal__content .input-field-label {
    font-size: calc(var(--space-half-quarter) + var(--space-eighth));
    line-height: var(--space);
    color: var(--primary-very-dark-color);

}

.profile-basic-information-modal__nationality__input .MuiFormLabel-root {
    font-family: var(--secondary-font);
    font-size: calc(var(--space-half-quarter) + var(--space-eighth));
    line-height: var(--space);
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.profile-basic-information-modal__nationality__input .MuiAutocomplete-inputRoot [class*="MuiOutlinedInput-root"] {
    border: 1px solid var(--new-input-background-color);
}

.profile-basic-information-modal__weight .input-field-input, 
.profile-basic-information-modal__height .input-field-input {
    background-color: var(--white-color);
    border: 1px solid var(--new-input-background-color);
}

.profile-basic-information-modal__unit-type .select-field-input {
    background-color: var(--white-color);
    border: 1px solid var(--new-input-background-color);
}

.profile-basic-information-modal__unit-type .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before {
    border: none !important;
}
.profile-basic-information-modal__unit-type .MuiInput-underline.select-field-input:before {
    border: none;
    transition: none;
}
.profile-basic-information-modal__unit-type .MuiInputBase-root .MuiInput-root .MuiInput-underline .select-field-input  .Mui-focused .Mui-focused {
    border-style: none !important;
}

.profile-basic-information-modal__unit-type .MuiListItemText-multiline .MuiListItemText-secondary {
    display: none;
}

.profile-basic-information-modal__unit-type .MuiSelect-select:focus {
    background-color: unset;
}

.profile-basic-information-modal__unit-type .select-field-clean__icon-list {
    margin: 0;
}

.profile-basic-information__nationality .MuiAutocomplete-root .input-field-autocomplete-with-search__list__country-logo {
    border: 1px solid var(--new-input-background-color);
    border-radius: 9px;
}

.profile-basic-information__nationality .MuiAutocomplete-root .input-field-autocomplete-with-search__list__country-logo .MuiListItem-root {
    gap: 10px;
}

.profile-basic-information-modal__content .input-field-autocomplete-with-search__list__country-logo__label {
    font-size: calc(var(--space-half-quarter) + var(--space-eighth));
    line-height: var(--space);
    color: var(--primary-very-dark-color);
    margin-bottom: 4px;

}

.profile-basic-information__nationality.input-field-auto-search  {
    margin: 45px 0 18px 0;
}

.profile-basic-information__nationality .input-field-autocomplete-search label {
    font-family: var(--secondary-font);
    font-size: calc(var(--space-half-quarter) + var(--space-eighth));
    line-height: var(--space);
    color: var(--primary-very-dark-color);
    font-weight: var(--font-medium);
}

.profile-basic-information__nationality__container .MuiAutocomplete-popperDisablePortal{
    position: fixed;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */
    .profile-basic-information-modal .modal2__container {
        width: 100%;
        margin: 0;
        border-radius: 0;
        max-height: 100%;
        height: 100%;
    }  
    
    .profile-basic-information-modal .modal2__content {
        height: 100%;
    }

    .profile-basic-information-modal__content {
        margin: 0 16px;
    }

    .profile-basic-information-modal__birthday .input-field-input {
        width: 100%;
    }

    .profile-basic-information-modal__weight.input-field, .profile-basic-information-modal__height.input-field {
        width: 50%;
    }
    .profile-basic-information-modal__unit-type.select-field {
        width: 50%;
    }

    .profile-basic-information-modal__actions {
        position: absolute;
        bottom: 0;
        width: 100%;
    }

    .profile-basic-information-modal__actions.form__actions .primary-button {
        width: 100%;
    }

    .profile-basic-information-modal .modal2__header {
        border-bottom: 1px solid var(--new-input-background-color);
        padding: var(--space-half-quarter) var(--space);
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/profiles/components/profile-basic-information-modal/ProfileBasicInformationModalComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,oCAAoC;IACpC,mDAAmD;AACvD;;AAEA;;IAEI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,uDAAuD;AAC3D;;AAEA;IACI,gEAAgE;IAChE,yBAAyB;IACzB,qCAAqC;;AAEzC;;AAEA;IACI,kCAAkC;IAClC,gEAAgE;IAChE,yBAAyB;IACzB,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,mDAAmD;AACvD;;AAEA;;IAEI,oCAAoC;IACpC,mDAAmD;AACvD;;AAEA;IACI,oCAAoC;IACpC,mDAAmD;AACvD;;AAEA;IACI,uBAAuB;AAC3B;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,mDAAmD;IACnD,kBAAkB;AACtB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gEAAgE;IAChE,yBAAyB;IACzB,qCAAqC;IACrC,kBAAkB;;AAEtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,gEAAgE;IAChE,yBAAyB;IACzB,qCAAqC;IACrC,+BAA+B;AACnC;;AAEA;IACI,eAAe;AACnB;;AAEA,yCAAyC,4BAA4B;IACjE;QACI,WAAW;QACX,SAAS;QACT,gBAAgB;QAChB,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,0DAA0D;QAC1D,+CAA+C;IACnD;AACJ","sourcesContent":[".profile-basic-information-modal__content {\n    margin: 0 85px;\n}\n\n\n.profile-basic-information-modal__weight-height {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.profile-basic-information-modal .modal2__container {\n    width: 30%;\n}\n\n.input-field.profile-basic-information-modal__birthday {\n    margin: 54px 0 0 0;\n\n}\n\n.profile-basic-information-modal__title.baloa-table-column {\n    color: var(--primary-very-dark-color);\n    margin-top: 18px;\n}\n\n.profile-basic-information-modal__birthday .input-field-input {\n    width: 50%;\n    background-color: var(--white-color);\n    border: 1px solid var(--new-input-background-color);\n}\n\n.profile-basic-information-modal__weight.input-field,\n.profile-basic-information-modal__height.input-field {\n    width: 45%;\n    margin: 45px 0 0 0;\n}\n\n.profile-basic-information-modal__unit-type.select-field {\n    margin: 45px 0 0 0;\n    width: 25%;\n}\n\n.profile-basic-information-modal__actions {\n    display: flex;\n    justify-content: flex-end;\n    border-top: 1px solid var(--new-input-background-color);\n}\n\n.profile-basic-information-modal__content .input-field-label {\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth));\n    line-height: var(--space);\n    color: var(--primary-very-dark-color);\n\n}\n\n.profile-basic-information-modal__nationality__input .MuiFormLabel-root {\n    font-family: var(--secondary-font);\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth));\n    line-height: var(--space);\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.profile-basic-information-modal__nationality__input .MuiAutocomplete-inputRoot [class*=\"MuiOutlinedInput-root\"] {\n    border: 1px solid var(--new-input-background-color);\n}\n\n.profile-basic-information-modal__weight .input-field-input, \n.profile-basic-information-modal__height .input-field-input {\n    background-color: var(--white-color);\n    border: 1px solid var(--new-input-background-color);\n}\n\n.profile-basic-information-modal__unit-type .select-field-input {\n    background-color: var(--white-color);\n    border: 1px solid var(--new-input-background-color);\n}\n\n.profile-basic-information-modal__unit-type .MuiInput-underline.select-field-input:hover:not(.Mui-disabled):before {\n    border: none !important;\n}\n.profile-basic-information-modal__unit-type .MuiInput-underline.select-field-input:before {\n    border: none;\n    transition: none;\n}\n.profile-basic-information-modal__unit-type .MuiInputBase-root .MuiInput-root .MuiInput-underline .select-field-input  .Mui-focused .Mui-focused {\n    border-style: none !important;\n}\n\n.profile-basic-information-modal__unit-type .MuiListItemText-multiline .MuiListItemText-secondary {\n    display: none;\n}\n\n.profile-basic-information-modal__unit-type .MuiSelect-select:focus {\n    background-color: unset;\n}\n\n.profile-basic-information-modal__unit-type .select-field-clean__icon-list {\n    margin: 0;\n}\n\n.profile-basic-information__nationality .MuiAutocomplete-root .input-field-autocomplete-with-search__list__country-logo {\n    border: 1px solid var(--new-input-background-color);\n    border-radius: 9px;\n}\n\n.profile-basic-information__nationality .MuiAutocomplete-root .input-field-autocomplete-with-search__list__country-logo .MuiListItem-root {\n    gap: 10px;\n}\n\n.profile-basic-information-modal__content .input-field-autocomplete-with-search__list__country-logo__label {\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth));\n    line-height: var(--space);\n    color: var(--primary-very-dark-color);\n    margin-bottom: 4px;\n\n}\n\n.profile-basic-information__nationality.input-field-auto-search  {\n    margin: 45px 0 18px 0;\n}\n\n.profile-basic-information__nationality .input-field-autocomplete-search label {\n    font-family: var(--secondary-font);\n    font-size: calc(var(--space-half-quarter) + var(--space-eighth));\n    line-height: var(--space);\n    color: var(--primary-very-dark-color);\n    font-weight: var(--font-medium);\n}\n\n.profile-basic-information__nationality__container .MuiAutocomplete-popperDisablePortal{\n    position: fixed;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n    .profile-basic-information-modal .modal2__container {\n        width: 100%;\n        margin: 0;\n        border-radius: 0;\n        max-height: 100%;\n        height: 100%;\n    }  \n    \n    .profile-basic-information-modal .modal2__content {\n        height: 100%;\n    }\n\n    .profile-basic-information-modal__content {\n        margin: 0 16px;\n    }\n\n    .profile-basic-information-modal__birthday .input-field-input {\n        width: 100%;\n    }\n\n    .profile-basic-information-modal__weight.input-field, .profile-basic-information-modal__height.input-field {\n        width: 50%;\n    }\n    .profile-basic-information-modal__unit-type.select-field {\n        width: 50%;\n    }\n\n    .profile-basic-information-modal__actions {\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n    }\n\n    .profile-basic-information-modal__actions.form__actions .primary-button {\n        width: 100%;\n    }\n\n    .profile-basic-information-modal .modal2__header {\n        border-bottom: 1px solid var(--new-input-background-color);\n        padding: var(--space-half-quarter) var(--space);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
